import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  connectCloudAccountContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginTop: theme.spacing(1),
    width: '100%',
  },
  connectCloudAccountHeading: {
    fontStyle: theme.typography.fontFamily,
    fontSize: '14px',
    color: theme.palette.labraText.description,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  fieldRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
  },
  secondaryFieldRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    width: '100%',
  },
  field: {
    width: '50%',
  },
  endIcon: {
    height: '16px',
    width: '16px',
  },
  personaSection: {
    marginTop: theme.spacing(0.25),
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
  },
  verticalDevider: {
    width: theme.spacing(0.125),
    height: theme.spacing(3.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
    background: theme.palette.dividerV2.main,
    marginRight: theme.spacing(0.75),
  },
  verticalDeviderButtons: {
    width: theme.spacing(0.125),
    background: theme.palette.dividerV2.main,
    marginLeft: theme.spacing(0.5),
  },
  testConnection: {
    margin: theme.spacing(1, 0),
  },
}))
